import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Lang } from '../types';
import { RootState } from '../store';

export interface LangState {
  lang: Lang;
}

const initialState: LangState = {
  lang: (localStorage.getItem('lang') as Lang) || Lang.de,
};

export const langSlice = createSlice({
  name: 'lang',
  initialState,
  reducers: {
    setLang: (state, action: PayloadAction<Lang>) => {
      state.lang = action.payload;
      localStorage.setItem('lang', action.payload);
    },
  },
});

export const { setLang } = langSlice.actions;

export default langSlice.reducer;

export const selectLang = (state: RootState) => state.lang.lang;
